var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zelle",
    transform: "translate(0.554 0.554)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150345",
    "data-name": "Rectangle 150345",
    width: 32,
    height: 32,
    transform: "translate(-0.554 -0.554)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zelle_logo",
    transform: "translate(7.683 2.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18233",
    "data-name": "Group 18233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M238.687-457.506l-5.34-.049v3.543h8.85L233-442.224v3h5.687v3.453H242.1v-3.453h5.8a.913.913,0,0,0-.243-.852,8.3,8.3,0,0,1-1.293-1.911c-.171-.333-.3-.732-.349-.765-1.142-.052-7.714-.039-7.711-.08l9.205-11.861v-2.812H242.1V-461h-3.412Z",
    transform: "translate(-233 461)",
    fill: "#6d1fd4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZelle);
export default __webpack_public_path__ + "static/media/Zelle.9903049452fed944e9fa538eb674fa9d.svg";
export { ForwardRef as ReactComponent };